import * as yup from 'yup';

export const chooseSubjectSchema = yup.object().shape({
  topic: yup
    .string()
    .required('O assunto é obrigatório')
    .test('not-zero', 'Selecione um assunto', value => value !== ''),
});
